import { NavigationItem } from 'components/layout'
import { TWorkspaceType } from 'components/layout/WorkspacePicker'
import { TFunction } from 'i18next'
import { BiObjectsVerticalCenter } from 'react-icons/bi'
import { BsFileRuled } from 'react-icons/bs'
import { FaNetworkWired, FaUsers } from 'react-icons/fa'
import { FiCpu } from 'react-icons/fi'
import { GiArtificialIntelligence } from 'react-icons/gi'
import { HiOutlineLocationMarker } from 'react-icons/hi'
import { MdOutlineNotificationImportant } from 'react-icons/md'
import { RiRedPacketLine, RiRouterLine } from 'react-icons/ri'
import {
  TbBinary,
  TbBuilding,
  TbFileDescription,
  TbFileReport,
  TbHome,
  TbLayout2,
  TbList,
  TbMail,
  TbMapSearch,
  TbTag,
} from 'react-icons/tb'
import { r } from './routes'

export const loraNavigationConfig: (t: TFunction) => NavigationItem[] = t => [
  {
    label: t('dashboard.single'),
    type: 'link',
    icon: TbHome,
    href: r['panel'],
  },
  {
    label: t('location.map'),
    type: 'link',
    icon: TbMapSearch,
    href: r['map'],
  },
  {
    type: 'link',
    label: t('location.plural'),
    href: r['locations.list'],
    icon: HiOutlineLocationMarker,
    permissionId: 'locations',
  },
  {
    type: 'link',
    label: t('deviceGroup.plural'),
    icon: TbLayout2,
    href: r['deviceGroup.list'],
    permissionId: 'deviceGroups',
  },
  {
    type: 'divider',
    label: t('generic.lorawan'),
    permissionId: 'lorawans',
  },

  {
    type: 'link',
    label: t('sensor.gatewaysMenu'),
    icon: RiRouterLine,
    href: r['gateways.list'],
    permissionId: 'lorawans',
  },
  {
    type: 'link',
    label: t('sensor.devicesMenu'),
    icon: FiCpu,
    href: r['loraDevices.list'],
    permissionId: 'lorawans',
  },
  {
    type: 'link',
    label: t('sensor.tags'),
    icon: TbTag,
    href: r['tag.list'],
    permissionId: 'devices',
  },
  {
    type: 'linkGroup',
    icon: TbBinary,
    label: t('generic.data'),
    permissionId: 'lorawans',
    links: [
      {
        label: t('parser.plural'),
        link: r['parser.list'],
      },
      {
        label: t('model.plural'),
        link: r['model.list'],
      },
      {
        label: t('generic.indicators'),
        link: r['indicator.list'],
      },
    ],
  },
  {
    type: 'divider',
    label: t('alert.plural'),
    permissionId: 'alerts',
  },
  {
    type: 'link',
    label: t('alert.templates'),
    href: r['alertRule.list'],
    icon: BsFileRuled,
    permissionId: 'alerts',
  },
  {
    type: 'link',
    label: t('alert.plural'),
    href: r['alert.list'],
    icon: MdOutlineNotificationImportant,
    permissionId: 'alerts',
  },
  {
    type: 'divider',
    label: t('report.plural'),
    permissionId: 'reporting',
  },
  {
    type: 'link',
    label: t('report.plural'),
    href: r['report.list'],
    icon: TbFileReport,
    permissionId: 'reporting',
  },
  {
    type: 'link',
    label: t('report.templatePlural'),
    href: r['reportTemplate.list'],
    icon: TbFileDescription,
    permissionId: 'reporting',
  },
  {
    type: 'link',
    label: t('loginHistory.plural'),
    href: r['loginHistory.list'],
    icon: TbList,
    permissionId: 'login-history',
  },
]

export const snmpNavigationConfig: (t: TFunction) => NavigationItem[] = t => [
  {
    label: t('dashboard.single'),
    type: 'link',
    icon: TbHome,
    href: r['panel'],
  },
  {
    type: 'link',
    label: t('deviceGroup.plural'),
    icon: TbLayout2,
    href: r['deviceGroup.list'],
    permissionId: 'deviceGroups',
  },
  {
    type: 'link',
    label: t('location.plural'),
    href: r['locations.list'],
    icon: HiOutlineLocationMarker,
    permissionId: 'locations',
  },
  {
    type: 'divider',
    label: t('typeCode.SNMP'),
    permissionId: 'snmp',
  },
  {
    type: 'link',
    label: t('snmp.devices'),
    icon: FaNetworkWired,
    href: r['snmpDevices.list'],
    permissionId: 'snmp',
  },
  {
    type: 'link',
    label: t('sensor.tags'),
    icon: TbTag,
    href: r['tag.list'],
    permissionId: 'devices',
  },
  {
    type: 'link',
    label: t('snmp.oids'),
    icon: BiObjectsVerticalCenter,
    href: r['oids.list'],
    permissionId: 'snmp',
  },
  {
    type: 'link',
    label: t('packet.plural'),
    href: r['snmpPacket.list'],
    icon: RiRedPacketLine,
    permissionId: 'snmp',
  },
  {
    type: 'divider',
    label: t('alert.plural'),
    permissionId: 'alerts',
  },
  {
    type: 'link',
    label: t('alert.templates'),
    href: r['alertRule.list'],
    icon: BsFileRuled,
    permissionId: 'alerts',
  },
  {
    type: 'link',
    label: t('alert.plural'),
    href: r['alert.list'],
    icon: MdOutlineNotificationImportant,
    permissionId: 'alerts',
  },
  {
    type: 'divider',
    label: t('report.plural'),
    permissionId: 'reports',
  },
  {
    type: 'link',
    label: t('report.plural'),
    href: r['report.list'],
    icon: TbFileReport,
    permissionId: 'reports',
  },
  {
    type: 'link',
    label: t('report.templatePlural'),
    href: r['reportTemplate.list'],
    icon: TbFileDescription,
    permissionId: 'reports',
  },
  {
    type: 'link',
    label: t('loginHistory.plural'),
    href: r['loginHistory.list'],
    icon: TbList,
    permissionId: 'login-history',
  },
]
export const adminNavigationConfig: (t: TFunction) => NavigationItem[] = t => [
  {
    type: 'link',
    label: t('user.users'),
    icon: FaUsers,
    href: r['user.list'],
  },
  {
    type: 'divider',
    label: t('generic.qrCodes'),
  },
  {
    type: 'link',
    label: t('sensor.gatewaysMenu'),
    icon: RiRouterLine,
    href: r['qrCodes.gateways.list'],
  },
  {
    type: 'link',
    label: t('sensor.devicesMenu'),
    icon: FiCpu,
    href: r['qrCodes.loraDevices.list'],
  },
  {
    type: 'divider',
    label: t('generic.systemData'),
    permissionId: 'emails',
  },
  {
    type: 'link',
    label: t('email.plural'),
    href: r['emails.list'],
    icon: TbMail,
    permissionId: 'emails',
  },
  {
    type: 'link',
    label: t('organization.plural'),
    href: r['organizations.list'],
    icon: TbBuilding,
    permissionId: 'organizations',
  },
  {
    type: 'link',
    label: t('aiSubsystem.plural'),
    href: r['aiSubsystem'],
    icon: GiArtificialIntelligence,
  },
  {
    type: 'link',
    label: t('loginHistory.plural'),
    href: r['loginHistory.list'],
    icon: TbList,
    permissionId: 'login-history',
  },
]

const navigationConfig = new Map<
  TWorkspaceType,
  (t: TFunction) => NavigationItem[]
>()
navigationConfig.set('lorawan', loraNavigationConfig)
navigationConfig.set('snmp', snmpNavigationConfig)
navigationConfig.set('admin', adminNavigationConfig)

export { navigationConfig }
